<script>
export default {
    name: "IconDoc"
}
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
        <path fill="currentColor" fill-rule="evenodd"
              d="M16 15a1 1 0 0 1-1 1H5a1 1 0 0 1 0-2h10a1 1 0 0 1 1 1ZM5 10h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2ZM4 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Zm14 10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h9v4a2 2 0 0 0 2 2h4v9Zm1.707-11.293L14.293.293a1 1 0 0 0-.707-.292H2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6.415a1 1 0 0 0-.293-.708Z"></path>
    </svg>
</template>

<style scoped lang="scss">

</style>
